import { inject, Injectable } from '@angular/core';
import { Timestamp } from '@firebase/firestore';
import { EventLog } from './event-logs-collection.models';
import { FirestoreService } from '../../firestore.service';
import { FIRESTORE_COLLECTIONS } from '../../firestore.constants';

@Injectable({
  providedIn: 'root',
})
export class EventLogsCollectionService {
  private readonly _firestoreService = inject(FirestoreService);

  public async getEventLogsByDateRange(startDate: Date, endDate: Date): Promise<EventLog[]> {
    return this._firestoreService.getDocuments<EventLog>({
      collectionName: FIRESTORE_COLLECTIONS.EVENT_LOGS,
      filters: [
        { field: 'dateTimeLogged', operator: '>=', value: Timestamp.fromDate(startDate) },
        { field: 'dateTimeLogged', operator: '<=', value: Timestamp.fromDate(endDate) },
      ],
      order: [{ field: 'dateTimeLogged', direction: 'desc' }],
    });
  }
}
